import React, { FC, useEffect, useState } from "react";
import classes from "./MediaReviews.module.css";
import { motion } from "framer-motion";

type MediaReviewsProps = {
  mediaReviews: any;
  windowWidth: number;
  type: "series" | "movie";
  handleMouseDown: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleMouseUp: (
    event: React.MouseEvent<HTMLButtonElement>,
    reviewId: number,
  ) => void;
  handleMouseMove: () => void;
};

const MediaReviews: FC<MediaReviewsProps> = ({
  mediaReviews,
  windowWidth,
  type,
  handleMouseDown,
  handleMouseMove,
  handleMouseUp,
}) => {
  const [leftConstraint, setLeftConstraint] = useState<number>(0);

  useEffect(() => {
    const updateConstraints = () => {
      if (window.innerWidth <= 800) {
        setLeftConstraint(
          10 +
            mediaReviews?.result.length * 320 +
            mediaReviews?.result.length * 20 +
            mediaReviews?.result.length * 1 -
            windowWidth
        );
      } else {
        setLeftConstraint(
          window.innerWidth * 0.05 +
            mediaReviews?.result.length * 320 +
            mediaReviews?.result.length * 20 +
            mediaReviews?.result.length * 1 -
            windowWidth
        );
      }
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);

    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, [windowWidth, mediaReviews]);

  return (
    <div className={classes.carousel_container}>
      <motion.div
        className={classes.section_review_card}
        style={{
          gridTemplateColumns: `repeat(${mediaReviews?.result.length}, 320px)`,
        }}
        drag="x"
        dragConstraints={{
          top: 0,
          left: -leftConstraint,
          right: 0,
          bottom: 0,
        }}
        transition={{
          type: "spring",
          damping: 100,
          stiffness: 100,
        }}
      >
        {mediaReviews?.result?.map((data: any, idx: number) => {
          return (
            <button
              className={classes.review_card}
              key={idx}
              onMouseDown={(event) => handleMouseDown(event)}
              onMouseUp={(event) => handleMouseUp(event, data?.id)}
              onMouseMove={handleMouseMove}
            >
              <div className={classes.review_rating_container}>
                <img
                  src="/assets/images/star.png"
                  alt="star"
                  className={classes.review_star}
                />
                <div className={classes.review_rating_sub_container}>
                  <p className={classes.review_rating}>{data?.stars_rated}</p>
                  <span className={classes.slash}>/</span>
                  <p className={classes.review_rating_out_of}>10</p>
                </div>
              </div>

              <div className={classes.review_intro_container}>
                <p className={classes.review_headline}>
                  {JSON.parse(data?.review_headline)}
                </p>
                <div className={classes.review_by}>
                  <p className={classes.username}>{data?.username}</p>
                  <p className={classes.review_date}>
                    {new Date(data?.date_time).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                </div>
              </div>

              <div className={classes.review_container}>
                <p
                  className={classes.review}
                  dangerouslySetInnerHTML={{
                    __html: JSON.parse(data?.review).replace(/\n/g, "<br />"),
                  }}
                ></p>
              </div>
            </button>
          );
        })}
      </motion.div>
    </div>
  );
};

export default MediaReviews;
